


















import { RoleType } from "@/shared/types";
import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";

@Component({ components: {} })
export default class RoleAdd extends Vue {

  $validator: Validator;
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();

  get isRolePermissionsEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions || this.featureFlagStore.flags.hsa7246AdminInitialUserCreation;
  }

  get isFeatureFlagAvailable () {
    return this.featureFlagStore.featureFlagsAvailable;
  }

  roleTypeName = "Admin Portal";
  role = {
    name: undefined,
    type: RoleType.Admin,
  };

  onSubmit () {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        this.employerRolePermissionStore.createRole({ roleName: this.role.name, roleType: this.role.type } as any)
            .then(resp => {
              if (resp) {
                this.returnToListPage();
              }
            });
      }
    });
  }

  returnToListPage () {
    this.$router.push("/role-permissions-management/role-permission-list");
  }
}
